const keyGen = (pre, idx) => {
    const key = `${pre}_${idx}_${new Date().getTime()}`;
    return key;
};

export default keyGen;
